import { Service } from '@angular/core';
import { DomNewSiteRedirectStrategy } from './dom-new-site-redirect.strategy';

@Service()
export class DomNewSiteRedirectNoopStrategy implements DomNewSiteRedirectStrategy {
  public init(): void {}
}
